import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.css']
})
export class RequestDetailsComponent implements OnInit {

  constructor(private dialog: MatDialogRef<RequestDetailsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { status: string, requested_at: string, completed_at: string | null, reason: string, note: string, upload_link: string}) {
  }
  closeAction() {
    this.dialog.close('cancel');
  }

  ngOnInit(): void {
  }

}
